import { Loader2, Workflow, CheckCircle } from 'lucide-react'
import type { NodeExecution } from '@/types/orchestrator'

interface CompactNodeProgressProps {
  nodes: NodeExecution[]
}

/**
 * Compact inline workflow progress indicator.
 * Shows "3/5 steps complete - Running: Task Executor" in a single line.
 */
export function CompactNodeProgress({ nodes }: CompactNodeProgressProps) {
  if (nodes.length === 0) return null

  const completed = nodes.filter((n) => n.status === 'complete').length
  const running = nodes.find((n) => n.status === 'running')
  const allDone = completed === nodes.length

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground py-1.5 px-3 bg-muted/50 rounded-lg">
      {allDone ? (
        <CheckCircle className="h-3.5 w-3.5 text-success flex-shrink-0" />
      ) : (
        <Workflow className="h-3.5 w-3.5 flex-shrink-0" />
      )}
      <span>
        {completed}/{nodes.length} steps complete
      </span>
      {running && (
        <>
          <span className="text-border">|</span>
          <span className="flex items-center gap-1 text-primary">
            <Loader2 className="h-3 w-3 animate-spin" />
            {running.nodeName}
          </span>
        </>
      )}
    </div>
  )
}
